export const sexo: any = {
    FEMENINO: 'femenino',
    MASCULINO: 'masculino',

  };